module.exports = __webpack_public_path__ + "static/img/2012@2x.3324e89.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/dynamic/newEvents/2012@2x.png
// module id = VBA+
// module chunks = 1